module.exports = "/static/assets/0816dfdfed40f2f7ace5cf90ad44bebc.png";